
/** speed multiplier for speeds below */
const SPEED_FACTOR  = 0.004;

const Config = [
    {
        color: "#60c9e8",
        lineWidth: 5,
        speeds: [
            3 * SPEED_FACTOR,
            5 * SPEED_FACTOR,
            7 * SPEED_FACTOR,
            11 * SPEED_FACTOR
        ]
    }
    ,
    {
        color: "#009dcd",
        lineWidth: 3,
        speeds: [
            5 * SPEED_FACTOR,
            7 * SPEED_FACTOR,
            11 * SPEED_FACTOR,
            13 * SPEED_FACTOR,
        ]
    },
    {
        color: "#009acc",
        lineWidth: 2,
        speeds: [

            7 * SPEED_FACTOR,
            11 * SPEED_FACTOR,
            13 * SPEED_FACTOR,
            17 * SPEED_FACTOR,

        ]
    },
    {
        color: "#0086b0",
        lineWidth: 1,
        speeds: [
            3 * SPEED_FACTOR,
            7 * SPEED_FACTOR,
            5 * SPEED_FACTOR,
            11 * SPEED_FACTOR,
        ]
    },
    {
        color: "#006f91",
        lineWidth: 1,
        speeds: [
            3 * SPEED_FACTOR,
            11 * SPEED_FACTOR,
            7 * SPEED_FACTOR,
            5 * SPEED_FACTOR,
        ]
    }
];
export default Config;



// WEBPACK FOOTER //
// ./src/circles/config.js